import { styled } from 'styled-components';
import { media } from '@/styles/Qtheme';

export const SectionWrapper = styled.section`
  position: relative;
  width: 100%;
  min-height: 834px;
  background: #2b2f73;
  overflow: hidden;
  padding: 71px 0;
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #2b2f73;
  z-index: 0;
`;

export const PlanetsBg = styled.div`
  position: absolute;
  top: 50px;
  left: 46.71px;
  width: 1815.944px;
  height: 702.384px;
  z-index: 1;
  opacity: 0.8;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media ${media.mobile} {
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 1815.944px;
  }
`;

export const TrophyVectorGroup = styled.div`
  position: absolute;
  left: 15px;
  top: 233px;
  width: 382.99px;
  height: 352.791px;
  z-index: 2;
  opacity: 0.7;

  @media ${media.mobile} {
    display: none;
  }
`;

export const TrophyVector1 = styled.img`
  position: absolute;
  top: 34.85%;
  left: 34.2%;
  width: 23.025px;
  height: 110.024px;
  transform: rotate(249.572deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector2 = styled.img`
  position: absolute;
  top: 37.06%;
  left: 36.68%;
  width: 12.51px;
  height: 93.013px;
  transform: rotate(249.572deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector3 = styled.img`
  position: absolute;
  top: 45.33%;
  left: 31.9%;
  width: 41.007px;
  height: 195.945px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector4 = styled.img`
  position: absolute;
  top: 37.91%;
  left: 15.64%;
  width: 88.41px;
  height: 185.002px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector5 = styled.img`
  position: absolute;
  top: 85.15%;
  left: 26.1%;
  width: 79.189px;
  height: 14.276px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector6 = styled.img`
  position: absolute;
  top: 46.71%;
  left: 49.54%;
  width: 53.344px;
  height: 130.278px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector7 = styled.img`
  position: absolute;
  top: 32.97%;
  left: 12.81%;
  width: 81.375px;
  height: 119.493px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector8 = styled.img`
  position: absolute;
  top: 45.31%;
  left: 0;
  width: 46.188px;
  height: 47.165px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector9 = styled.img`
  position: absolute;
  top: 85.04%;
  left: 60.41%;
  width: 27.425px;
  height: 24.529px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector10 = styled.img`
  position: absolute;
  top: 52.72%;
  left: 84.34%;
  width: 44.477px;
  height: 44.574px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector11 = styled.img`
  position: absolute;
  top: 64.67%;
  left: 32.12%;
  width: 0.941px;
  height: 0.572px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector12 = styled.img`
  position: absolute;
  top: 49.34%;
  left: 35.08%;
  width: 61.89px;
  height: 60.183px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyVector13 = styled.img`
  position: absolute;
  top: 0;
  left: 70.5%;
  width: 53.916px;
  height: 55.486px;
  transform: rotate(332.644deg);
  object-fit: contain;
  transform-origin: center;
`;

export const TrophyNumber = styled.div`
  position: absolute;
  top: 52.45%;
  left: 41.25%;
  width: 23.052px;
  height: 58.116px;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 52px;
  line-height: normal;
  color: #ffffff;
  transform: rotate(342.269deg);
  transform-origin: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Coin1 = styled.div`
  position: absolute;
  left: 123px;
  top: 645px;
  width: 90px;
  height: 74px;
  z-index: 2;
  opacity: 0.6;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media ${media.mobile} {
    display: none;
  }
`;

export const Coin2 = styled.div`
  position: absolute;
  left: 1557px;
  top: 244px;
  width: 87px;
  height: 81px;
  z-index: 2;
  opacity: 0.6;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media ${media.mobile} {
    display: none;
  }
`;

export const Coin3 = styled.div`
  position: absolute;
  left: 1758px;
  top: 425px;
  width: 66px;
  height: 55px;
  z-index: 2;
  opacity: 0.6;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media ${media.mobile} {
    display: none;
  }
`;

export const Coin4 = styled.div`
  position: absolute;
  left: 1545px;
  top: 583px;
  width: 92px;
  height: 107px;
  z-index: 2;
  opacity: 0.6;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media ${media.mobile} {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  position: relative;
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 419px;
  z-index: 3;

  @media ${media.mobile} {
    padding: 0 20px;
  }
`;

export const SectionTitle = styled.h2`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 32px;
  line-height: 38px;
  color: #ffffff;
  margin: 0 0 40px 0;
  text-align: left;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
